import React, { useEffect, useState } from "react";
import { Languages } from "lucide-react";
import { LANGUAGES, currentLanguage, setLanguage, t } from "@/i18n";

/**
 * Two labels, one click. Deliberately not a flag: a flag names a country, and
 * the same language is spoken in several.
 */
export const LanguageSwitch = ({ className = "" }) => {
  const [lang, setLang] = useState(currentLanguage());

  useEffect(() => {
    const sync = () => setLang(currentLanguage());
    window.addEventListener("languagechange", sync);
    return () => window.removeEventListener("languagechange", sync);
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-full p-0.5 ${className}`}
      style={{ backgroundColor: "var(--paper-2)" }}
      role="group"
      aria-label={t("lang.switch")}
      data-testid="language-switch"
    >
      <Languages
        className="ml-1.5 h-3 w-3 shrink-0"
        style={{ color: "var(--muted-ink)" }}
        aria-hidden
      />
      {Object.entries(LANGUAGES).map(([code, label]) => (
        <button
          key={code}
          type="button"
          onClick={() => setLanguage(code)}
          aria-pressed={lang === code}
          className="rounded-full px-2 py-0.5 text-[11.5px] font-medium transition-colors"
          style={{
            backgroundColor: lang === code ? "#ffffff" : "transparent",
            color: lang === code ? "var(--ink)" : "var(--muted-ink)",
          }}
          data-testid={`language-${code}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
